var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_18311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Essentials/gear",
    rx: 0.5,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_18311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.34 2.66C13.04 2.66 12 3.71 12 5.01C12 6.81 10.04 7.94 8.48 7.04C7.36 6.39 5.92 6.77 5.28 7.89L3.62 10.76C2.97 11.88 3.36 13.32 4.48 13.96C6.04 14.87 6.04 17.12 4.48 18.03C3.36 18.67 2.97 20.11 3.62 21.23L5.28 24.1C5.92 25.22 7.36 25.6 8.48 24.95C10.04 24.05 12 25.18 12 26.98C12 28.28 13.04 29.33 14.34 29.33L17.65 29.33C18.95 29.33 20 28.28 20 26.98C20 25.18 21.95 24.05 23.51 24.95C24.63 25.6 26.07 25.22 26.71 24.1L28.37 21.23C29.02 20.11 28.63 18.67 27.51 18.03C25.95 17.12 25.95 14.87 27.51 13.96C28.63 13.32 29.02 11.88 28.37 10.76L26.71 7.89C26.07 6.77 24.63 6.39 23.51 7.04C21.95 7.94 20 6.81 20 5.01C20 3.71 18.95 2.66 17.65 2.66L14.34 2.66ZM16 21.33C13.05 21.33 10.66 18.94 10.66 16C10.66 13.05 13.05 10.66 16 10.66C18.94 10.66 21.33 13.05 21.33 16C21.33 18.94 18.94 21.33 16 21.33Z",
    strokeOpacity: 1,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.5790e6414df983d2d0e369550022db6f.svg";
export { ForwardRef as ReactComponent };